export const NO_OP = () => {}

export const FILE_TO_UPLOAD = {
  // WARNIG: setting value 200MB to bites
  maxSize: 200 * Math.pow(1024, 2), // Tamaño máximo en bytes (200MB)
  type: "application/zip"
}
